export function mapByField<T>(
  collection: T[],
  field: keyof T,
): Record<string, T> {
  return collection.reduce((acc, item) => {
    acc[item[field] as string] = item;
    return acc;
  }, {} as Record<string, T>);
}

export function mapById<T extends { id?: string }>(
  collection: T[],
): Record<string, T> {
  return mapByField(collection, 'id');
}
